import type { CragRoute } from '../../../types/crag-route';

/**
 * The routes immediately either side of this one.
 *
 * Sectors are listed in the order they are walked past, so a route's neighbours
 * in that list are its neighbours on the cliff. Earlier in the list is **left**:
 * a topo is written left to right.
 *
 * A route being created has no place in the list yet and is treated as sitting
 * at its foot, which is where the panel adds it, so it has a left neighbour only.
 */
export function routeNeighbours(
  routes: CragRoute[],
  selectedRouteId: string | null
): { left?: CragRoute; right?: CragRoute } {
  const index = routes.findIndex((route) => route.id === selectedRouteId);
  const anchor = index === -1 ? routes.length : index;

  return { left: routes[anchor - 1], right: routes[anchor + 1] };
}

/** The same two as a list, for whoever draws them and does not mind which hand. */
export function routesBeside(routes: CragRoute[], selectedRouteId: string | null): CragRoute[] {
  const { left, right } = routeNeighbours(routes, selectedRouteId);

  return [left, right].filter((route): route is CragRoute => route !== undefined);
}
